import React from 'react';
import usePageTranslation from '../../../shared/hooks/usePageTranslation';
import LegalPage from '../components/LegalPage';
import LegalSection from '../components/LegalSection';
import LegalContactBlock from '../components/LegalContactBlock';

const MentionsLegales: React.FC = () => {
  const { t, loading } = usePageTranslation('public', 'MentionsLegales');

  if (loading) return null;

  return (
    <LegalPage
      title={t('title')}
      subtitle={t('subtitle')}
      lastUpdate={t('lastUpdate')}
      lastUpdateDate={t('lastUpdateDate')}
    >
      <LegalSection number={1} title={t('editor.title')}>
        <p className="text-lg text-gray-300 mb-4">
          <strong className="text-primary-400">OpSecours</strong> {t('editor.description')}
        </p>
        <p className="text-lg text-gray-300 mb-6">{t('editor.purpose')}</p>

        <h3 className="text-xl font-semibold text-white mb-3">{t('editor.legalInfo')}</h3>
        <ul className="space-y-2 mb-6">
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span><strong>{t('editor.owner')} :</strong> Bondi51</span>
          </li>
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span><strong>{t('editor.director')} :</strong> Bondi51</span>
          </li>
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span>
              <strong>{t('editor.email')} :</strong>{' '}
              <a href="mailto:support@opsecours.fr" className="text-primary-400 hover:text-primary-300 underline">
                support@opsecours.fr
              </a>
            </span>
          </li>
        </ul>

        <h3 className="text-xl font-semibold text-white mb-3">{t('editor.team')}</h3>
        <ul className="space-y-2">
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span><strong>{t('editor.mainDev')} :</strong> Bondi51</span>
          </li>
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span><strong>{t('editor.dev')} :</strong> Jeje181557, HyDroX_Tv, FR58, Louis chouzenoux19</span>
          </li>
        </ul>
      </LegalSection>

      <LegalSection number={2} title={t('hosting.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('hosting.description')}</p>
        <ul className="space-y-2">
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span><strong>{t('hosting.host')} :</strong> {t('hosting.hostValue')}</span>
          </li>
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span><strong>{t('hosting.address')} :</strong> {t('hosting.addressValue')}</span>
          </li>
          <li className="flex items-start text-gray-300">
            <span className="text-primary-400 font-bold mr-2">•</span>
            <span>
              <strong>{t('hosting.website')} :</strong>{' '}
              <a
                href="https://www.hostinger.fr"
                className="text-primary-400 hover:text-primary-300 underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.hostinger.fr
              </a>
            </span>
          </li>
        </ul>
      </LegalSection>

      <LegalSection number={3} title={t('intellectual.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('intellectual.description1')}</p>
        <p className="text-lg text-gray-300">{t('intellectual.description2')}</p>
      </LegalSection>

      <LegalSection number={4} title={t('links.title')}>
        <p className="text-lg text-gray-300">{t('links.description')}</p>
      </LegalSection>

      <LegalSection number={5} title={t('cookies.title')}>
        <p className="text-lg text-gray-300">{t('cookies.description')}</p>
      </LegalSection>

      <LegalSection number={6} title={t('liability.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('liability.description1')}</p>
        <p className="text-lg text-gray-300">{t('liability.description2')}</p>
      </LegalSection>

      <LegalSection number={7} title={t('law.title')}>
        <p className="text-lg text-gray-300">{t('law.description')}</p>
      </LegalSection>

      <LegalSection number={8} title={t('contact.title')}>
        <LegalContactBlock
          description={t('contact.description')}
          discord={t('contact.discord')}
          discordAction={t('contact.discordAction')}
          email={t('contact.email')}
          owner={t('contact.owner')}
        />
      </LegalSection>
    </LegalPage>
  );
};

export default MentionsLegales;
